module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-02.db67646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-02.jpg
// module id = lLB8
// module chunks = 1